module.exports = __webpack_public_path__ + "static/media/icon-add-goal.cdd89d87.svg";